export default function DonateSuccess() {
  return (
    <section className="max-w-3xl mx-auto py-16">
      <h1 className="text-2xl font-bold mb-4">Thank you for your donation!</h1>
      <p>We’ve received your contribution. A confirmation email is on the way.</p>
    </section>
  );
}
